module.exports = __webpack_public_path__ + "static/img/board.70ec945.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f1/board.png
// module id = nzk0
// module chunks = 0